import { Link } from '@chakra-ui/react';

interface Props {
  isStoryExpired: boolean;
  contentLink?: string;
  // Called when the viewer follows the tile out to the platform. Passing a
  // handler is how a caller opts into reacting to that (e.g. tracking); an
  // expired story renders no link, so it never fires.
  onLinkClick?: () => void;
  children: React.ReactNode;
}

export const ContentPreviewWrapper = ({
  isStoryExpired,
  contentLink,
  onLinkClick,
  children,
}: Props) => {
  if (isStoryExpired) {
    return <>{children}</>;
  }
  return (
    <Link
      href={contentLink}
      isExternal
      borderRadius="lg"
      overflow="hidden"
      _hover={{ textDecoration: 'none' }}
      onClick={onLinkClick}
    >
      {children}
    </Link>
  );
};
